/* eslint-disable @animech/axiom/no-references-in-top-level-values */
/* eslint-disable @animech/axiom/strict-function-syntax */
import { root } from "./property-definitions";
import {
	isRoundTable,
	type TableType,
	type Side,
	RECT_SIDES,
} from "./type-definitions";

// ---------------------------------------------------------------------------
// Table accessor (structurally identical to SideAccessors minus count)
// ---------------------------------------------------------------------------

export type TableAccessors = {
	materialWood: typeof root.tableMaterialWood;
	materialWood2: typeof root.tableMaterialWood2;
	materialMetal: typeof root.tableMaterialMetal;
	materialWeld: typeof root.tableMaterialWeld;
	materialEndcap: typeof root.tableMaterialEndcap;
	materialScrewAtlas: typeof root.tableMaterialScrewAtlas;
	materialScrewPhillips: typeof root.tableMaterialScrewPhillips;
	theme: typeof root.tableTheme;
};

export const tableAccessor: TableAccessors = {
	materialWood: root.tableMaterialWood,
	materialWood2: root.tableMaterialWood2,
	materialMetal: root.tableMaterialMetal,
	materialWeld: root.tableMaterialWeld,
	materialEndcap: root.tableMaterialEndcap,
	materialScrewAtlas: root.tableMaterialScrewAtlas,
	materialScrewPhillips: root.tableMaterialScrewPhillips,
	theme: root.tableTheme,
};

// ---------------------------------------------------------------------------
// Helper functions
// ---------------------------------------------------------------------------

/**
 * Returns active sides for a given table type.
 * Round tables use the single "round" side; rectangular tables use 4 sides.
 */
export function getActiveSides(table: TableType): readonly Side[] {
	return isRoundTable(table) ? (["round"] as const) : RECT_SIDES;
}
